import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  button: {
    fontType: 'Roboto',
    fontWeight: 500,
    fontSize: '13px',
    height: '30px',
    lineHeight: '22px',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#266733',
    },
    backgroundColor: '#347F42',
    borderRadius: '4px',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    alignItems: 'center',
    marginLeft: '8px',
    marginTop: '-3px',
  },
  alreadyCompleted: {
    '&.Mui-disabled': {
      color: '#347F42 !important',
      fontWeight: 600,
      fontSize: '13px',
    },
    color: '#347F42',
    marginRight: '8px',
    marginTop: '-3px',
    alignItems: 'center',
  },
}));
